<template>
  <div class="Introduction">
    <div class="Introduction-left">
      <div>
        <div class="Introduction-title">
          {{ info.title }}
          <!--政府星级普通星级-->
          <img v-lazy="'/images/zfxj/icon_'+info.state_star+'.png'" :key="info.state_star" height="20px" v-if="info.state_star>0"/>
          <img v-lazy="'/images/xj/icon_'+info.star+'.png'" :key="info.star" height="20px" v-else/>
        </div>
        <div class="Introduction-content">
          <!-- <span  class="hotel-star">{{info.star | formatVar('HotelStar')}}</span> -->
          <div><i class="el-icon-location-outline"></i>{{info.province_name}}省{{info.city_name}}市{{info.district_name}}{{info.address}}</div>
          <div class="Introduction-map text-login" @click="$emit('Map') ">查看地图</div>
        </div>
      </div>
      <div  class="introduction-inquiry" v-if="userInfo.type==2">
        <div class="Introduction-btn addInquiry mr-2" :class="isIdExist(inquiryList,info.id,'id')?'disableds':''" @click="!isIdExist(inquiryList,info.id,'id')?$emit('addQuote',info):$emit('cancelQuote',info)">
          {{isIdExist(inquiryList,info.id,'id')?'取消询价':'加入询价'}}
        </div>
        <div class="Introduction-btn" @click="$emit('orderConfirm',info)">
          确认单
        </div>
      </div>
    </div>
    <!--展示图片6张-->
    <div class="Introduction-pic" @click="$emit('photoAlbum')">
      <div class="Introduction-pic-oen" v-if="info.pic_arr" ><img v-lazy="ImgPreUrl+info.pic_arr[0]" height="14px" class="gallery-img"
        @mouseenter="isZoomed = 0" @mouseleave="isZoomed = -1" :style="{ transform: isZoomed==0 ? 'scale(1.1)' : 'scale(1)' }"/></div>
      <div class="Introduction-pic-two">
        <template v-for="(item,index) in info.pic_arr" >
        <div :key="index" v-if="index>0&&index<7">
          <img v-lazy="ImgPreUrl+item" height="14px" class="gallery-img" 
          @mouseenter="isZoomed = index" @mouseleave="isZoomed =-1" :style="{ transform: isZoomed==index? 'scale(1.1)' : 'scale(1)' }"/>
          <div v-if="index==6" class="Introduction-pic-mask">
            <i class="iconfont icon-tupian"></i>
            <span>查看所有{{info.totallength}}张图片</span>
          </div>
        </div>
        </template>
      </div>
    </div>
    <!--酒店设施介绍-->
    <div class="facilities">
      <div class="facilities-left">
        <!--酒店信息-->
        <div class="facilities-title">酒店信息</div>
        <div class="content mt-2">
          <div v-for="item in content" :key="item.name" class="content-circle">
            <i :class="['iconfont mr-1',item.icon]"></i>
            <span>{{info[item.value]}}{{item.quantity}}</span>
            <div>{{item.name}}</div>
          </div>
        </div>
        <div class="content mt-4">
          <div v-for="item in contentTwo" :key="item.name" class="content-circle">
            <i :class="['iconfont mr-1',item.icon]"></i>
            <span v-if="item.value=='fitmentdate'">{{info[item.value]| formatTimestamp(6)}}{{item.quantity}}</span>
            <span v-else>{{info[item.value]}}{{item.quantity}}</span>
            <div>{{item.name}}</div>
          </div>
        </div>
        <!--酒店简介文字-->
        <!-- <div class="facilities-title mt-3">酒店简介</div>
        <div>
          <p class="h7 mt-2 format-text" v-if="info.intro"
            v-html="introText"></p>
          <p class="h7 mt-2 format-text" v-else>欢迎通过订单雨预订本{{typeInfo.cn}}，享受团队最优价，期待您的光临</p>
        </div> -->
        <!-- <div class="facilities-icon">
          <div v-for="(item,index) in iconShow" :key="index">
            <i :class="['iconfont mr-1',item.icon]"></i>
            <span>{{item.name}}</span>
          </div>
        </div> -->
      </div>
      <!--简略地图-->
      <div class="facilities-content" @click="$emit('Map') ">
        <MapPosition id="tabMapInfo" :DisplayBasicInfo='info'></MapPosition>
      </div>
      <!--右侧浮动-二维码加询价清单-->
      <right-tab-bar></right-tab-bar>
    </div>
  </div>
</template>

<script>
import { mapState,mapGetters} from 'vuex';
import RightTabBar from '@/components/PublicComp/RightTabBar.vue';
import MapPosition from './MapPosition.vue'
export default {
  name: 'Introduction',
  components: {MapPosition,RightTabBar},
  props: {
    info: {},
  },
  data() {
    return {
      isZoomed: false,
      content:[
        {name:'客房',value:'room_count',icon:'icon-kefangleibie',quantity:'间'},
        {name:'双床房',value:'room_2_count',icon:'icon-chuang',quantity:'间'},
        {name:'会议室',value:'meeting_count',icon:'icon-huiyi',quantity:'间'},
        {name:'最大会议室',value:'meeting_area',icon:'icon-mianji2',quantity:'m²'}, 
      ],
      contentTwo:[
        {name:'停车场',value:'parking',icon:'icon-daba',quantity:''},
        {name:'最近装修',value:'fitmentdate',icon:'icon-dianpuzhuangxiu',quantity:'年'},
        {name:'已接团数',value:'team_num',icon:'icon-tuandui',quantity:'次'},
        {name:'已接人数',value:'people_num',icon:'icon-ren3',quantity:'人'}
      ]
    };
  },
  computed: {
      ...mapGetters(['userInfo']),
      ...mapState(['inquiryList']),
      //设施信息转换为图标
      iconShow() {
        let iconArr = [];
        this.$verify.stitch(this.info.facility).forEach(item => {
          this.$GVAR.FacilitiesBasiciconclass.forEach(v => {
            if (item === v.id) {
              iconArr.push({id:v.id,icon:v.iconClass,name:v.name});
            }
          });
        });
        return iconArr;
      },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 判断 id 是否存在
    isIdExist(arr, id, key) {
      return arr.some(item => item[key] === id)
    },
  }
};
</script>

<style lang="scss" scoped>
  .Introduction{
      background-color: #fff;
      width: 96%;
      padding: 2%;
      border-radius: 6px;
      text-align: left;
  }
  .Introduction-title{
    text-align: left;
    font-size: 24px;
    font-weight: bold;
  }
  .Introduction-content{
    margin-top: 6px;
    display: flex;
  }
  .Introduction-map{
    margin-left: 6px;
    cursor: pointer;
  }
  .Introduction-pic{
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    cursor: pointer;
  }
  .Introduction-pic-oen{
    width: 40%;
    height: 373px;
    overflow: hidden;
    border-radius: 4px;
    img{
      width: 100%;
      height: 100%;
      
    }
  }
  .Introduction-pic-two{
    width:59.5%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    >div{
      width:32.8%;
      height: 184px;
      margin-bottom: 6px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 
    transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), /* 缩放过渡（使用缓动函数增强质感） */
    filter 0.6s ease; /* 可选：添加亮度变化过渡 */
  }
  .facilities{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .facilities-title{
    font-size: 16px;
    font-weight: bold;
  }
  .facilities-left{
    width: 60%;

  }
  .facilities-content{
    width: 39%;
    height: 186px;
    margin-top: 24px;
    overflow: hidden;
    border-radius: 20px;
  }

  .content{
    width: 100%;
    display: flex;
    span{
      font-weight: bold;
      display: block;
      padding: 3px 0;
    }
    i{
      font-size: 30px;
    }
  }
  .content .content-circle{
    width: 50%;
    text-align: center;
    border-right: 1px #eee solid;
  } 
  .content .content-circle:last-child{
    border-right: none;
  }
  .Introduction-left{
    display: flex;
    justify-content: space-between;
  }
  .introduction-inquiry{
    display: flex;
  }
  .Introduction-btn{
    width: 100px;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    background-color: var(--smtc-color-primary);
    color: #fff;
    cursor: pointer;
  }
  .Introduction-pic-mask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #000;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .6);
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #fff;

    i{
      font-size: 20px;
    }
    span{
      margin-top: 10px;
    }
  }
  .addInquiry{
      background-color: initial;
      border: 1px var(--smtc-color-primary) solid;
      color: var(--smtc-color-primary);
  }
  .disableds{
      background-color: #dddd;
      border: 1px #ddd solid;
      color: #b2b2b2;
  }
</style>
